import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../../components/Avatar';
import './styles.css';

const SearchResultRenderer = ({ title, id, active, image, icon, description }) => (
  <div role="option" aria-selected={active} id={`global-search-box-item-${active ? 'active' : id}`}>
    <Avatar icon={icon} image={image} />
    <div styleName="item">
      {title && <div className="title">{title}</div>}
      {description && <div className="description">{description}</div>}
    </div>
  </div>
);
SearchResultRenderer.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SearchResultRenderer;
